/*
 * @Author: mayanxia 
 * @Date: 2022-08-22 16:41:09 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-08-23 14:33:29
 */

<!--增加补水操作员-->
<template>
    <a-modal
        :title="title"
        :width="800"
        :visible="visible"
        :confirmLoading="confirmLoading"
        :okButtonProps="{ props: {disabled: disableSubmit} }"
        :maskClosable="maskClosable"
        @ok="handleOk"
        @cancel="handleCancel"
        :cancelText="$t('关闭')">

        <a-spin :spinning="confirmLoading">
            <div class="form-contain">
                <a-divider orientation="left">{{ $t('用户信息') }}</a-divider>
                <detail-list>
                    <detail-list-item :term="$t('用户编号')">{{vocationdetail.userId}}</detail-list-item>
                    <detail-list-item :term="$t('用户姓名')">{{vocationdetail.userName}}</detail-list-item>
                    <detail-list-item :term="$t('手机号码')">{{vocationdetail.userPhone}}</detail-list-item>
                    <detail-list-item :term="$t('表编号')">{{vocationdetail.meterId}}</detail-list-item>
                    <detail-list-item :term="$t('用户地址')">{{vocationdetail.userAddr}}</detail-list-item>
                    <detail-list-item :term="$t('用水单价(元)')">{{vocationdetail.userPriceTotal}}</detail-list-item>
                    <detail-list-item :term="$t('价格名称')">{{vocationdetail.userPriceName}}</detail-list-item>
                    <detail-list-item :term="$t('单次最大购买金额(元)')">{{vocationdetail.maxBuyOnce}}</detail-list-item>
                    <detail-list-item :term="$t('最大囤积金额(元)')">{{vocationdetail.maxHording}}</detail-list-item>
                </detail-list>
                <a-divider orientation="left">{{ $t('补水申请信息') }}</a-divider>
                <detail-list>
                    <detail-list-item :term="$t('申请时间')">{{model.createTime}}</detail-list-item>
                    <detail-list-item :term="$t('申请人')">{{model.createBy}}</detail-list-item>
                    <detail-list-item :term="$t('订单号')">{{vocationdetail.orderId}}</detail-list-item>
                    <detail-list-item :term="$t('补水前余额(元)')">{{vocationdetail.userAccountNum}}</detail-list-item>
                    <detail-list-item :term="$t('交易方式')">{{vocationdetail.payWay== 1?$t('营业厅'):'--'}}</detail-list-item>
                    <detail-list-item :term="$t('计费类型')">{{vocationdetail.payType== 1?$t('按金额'):vocationdetail.payType== 2?$t('按吨数'):'--'}}</detail-list-item>
                    <detail-list-item :term="vocationdetail.payType== 1?$t('补水金额(元)'):vocationdetail.payType== 2?$t('补水吨数(吨)'):''">
                        {{vocationdetail.payType== 1?vocationdetail.buyWaterMoney:vocationdetail.payType== 2?vocationdetail.buyWaterCount:'--'}}
                    </detail-list-item>
                    <detail-list-item :term="$t('实际补水金额(元)')">{{vocationdetail.buyWaterMoney}}</detail-list-item>
                    <detail-list-item :term="$t('补水备注')" :itemCol="1">{{vocationdetail.remark}}</detail-list-item>
                </detail-list>
                <a-divider orientation="left">{{ $t('审核信息') }}</a-divider>
                <detail-list>
                    <detail-list-item :term="$t('审核状态')"> {{model.auditStatus==2?$t('审核通过'):model.auditStatus==1?$t('审核不通过'):$t('待审核')}}</detail-list-item>
                    <detail-list-item :term="$t('审核时间')">{{model.auditTime}}</detail-list-item>
                    <detail-list-item :term="$t('审核意见')" :itemCol="1">{{model.auditDetail}}</detail-list-item>
                </detail-list>
            </div>
        <!--
        <a-form-model ref="formModal" :model="model" :rules="rules" :colon="false" layout="vertical">
            <div>
                <a-row :gutter="24">
                    <a-col :xl="8" :lg="7" :md="8" :sm="24">
                        <a-form-model-item label="任务名称" prop="taskName">
                            <a-input placeholder="请输入任务名称" v-model="model.taskName"></a-input>
                        </a-form-model-item>
                    </a-col>
                    <a-col :xl="8" :lg="7" :md="8" :sm="24">
                        <a-form-model-item label="任务类型" prop="taskType">
                            <a-select placeholder="请选择" v-model="model.taskType">
                                <a-select-option :value="1">批量报装</a-select-option>
                                <a-select-option :value="2">批量建档</a-select-option>
                                <a-select-option :value="3">批量激活</a-select-option>
                                <a-select-option :value="4">批量删除</a-select-option>
                                <a-select-option :value="6">批量更新经纬度</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :xl="24" :lg="24" :md="24" :sm="24">
                        <a-form-model-item label="描述" prop="remark">
                            <a-textarea v-model="model.remark" rows="3" placeholder="请输入备注" style="width:100%"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </div>
        </a-form-model>
        -->
        </a-spin>
    </a-modal>
</template>

<script>
    import { postAction } from '@/api/manage'
    import DetailList from '@/components/tools/DetailList'
    const DetailListItem = DetailList.Item
    import { httpAction } from '@/api/manage'

    export default {
        name: 'UserApplyRecordModal',
        components: {
            DetailList,
            DetailListItem
        },
        props: {
            //表单禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        data () {
            return {
                title:this.$t('操作'),
                visible: false,
                disableSubmit:false,
                maskClosable:false,
                model: {},
                confirmLoading: false,
                url: {
                    add: "/auditprocess/auditUserLink/add",
                    edit: "/auditprocess/auditUserLink/edit",
                },
                vocationdetail: {}
            }
        },
        computed: {
            rules(){
                return {
                    taskName:[{ required: true, message: this.$t('请输入任务名称')}], //订单编号
                    taskType:[{ required: true, message: this.$t('请选择任务类型')}], //表类型
                }
            },
        },
        created () {
        
        },
        methods: {
            handleOk() {
                console.log("点击提交")
                // 触发表单验证
                this.$refs.formModal.validate(valid => {
                    if(valid) {
                      this.confirmLoading = true;
                      let httpurl = '';
                      let method = '';
                      if(!this.model.id){
                        httpurl+=this.url.add;
                        method = 'post';
                      }else{
                        httpurl+=this.url.edit;
                        method = 'put';
                      }
                      let formData = {...this.model};
                        httpAction(httpurl,formData,method).then((res) => {
                          this.confirmLoading = false
                          if(res.success){
                              this.$message.success(res.message)
                              this.$emit('ok')
                              this.close()
                          }else{
                              this.$message.warning(res.message)
                          }
                      })
                    }else{
                        return false
                    }
                })
            },
            add() {
                this.edit({});
            },
            edit (record) { 
                this.visible = true;
                this.model = Object.assign(this.model,record)
                if(this.model.vocationDetail) {
                    this.vocationdetail = JSON.parse(this.model.vocationDetail)
                }
            },
            close () {
                this.$emit('close');
                //this.$refs.formModal.resetFields()
                this.model = this.$options.data.call(this).model
                this.disableSubmit = false;
                this.visible = false;
            },

            handleCancel () {
                this.close();
            }
        }
    }
</script>
<style scoped>
    .ant-form-item >>> .ant-select{
    width: 100%;
    }
    .span {
    margin: 8px;
    }
    .detail-list >>> .content{
    line-height: normal;
    }
</style>